import { render, staticRenderFns } from "./AddCategoryModal.vue?vue&type=template&id=89af3d4e&scoped=true"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./AddCategoryModal.vue?vue&type=style&index=0&id=89af3d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89af3d4e",
  null
  
)

export default component.exports